<template>
	<div>
		<div class="ui grid">
			<div class="ten wide column margin-auto">
				<div class="ui segment segment-height">
					<p class="assessmentname_error">Bulk offline scheduling</p>
					<div class="ui stackaable two column grid padding-twenty">
						<div class="column">
							<assessmentname></assessmentname>
						</div>
						<div class="column">
							<form class="ui form">
								<input  placeholder="Please select interview location" class="search-location" type="text"
									 id="googlemaps" />
								<p v-if="location_error" class="location">Please select a location</p>
							</form>
						</div>
					</div>
					<div class="ui primary button isnext" v-if="isNext" v-on:click="next">Next</div>
					<div class="ui  grid" v-if="bulk_upload">
						<div class="three wide column margin-auto">
							<label id="file-select">
								<div class="select-button">
									<img src="https://static.talview.com/clients/bulk_upload.png" width="70px">
								</div>
								<input type="file" @change="handleFileChange" />
							<p class="text-blue margin-bottom-fibve">Click here to upload</p>
							</label>
								<p class="text-blue text-small">(.csv)</p>
					<p class="text-small">Dont have a template? <a href="https://static.talview.com/attachments/offline-schedule-3.csv" download>Download</a></p>
						</div>
					</div>
					<div v-if="isfile" class="margin-top-fifty" >
						<p>Total Count : {{ Total_count }}</p>
						<p>Success Count : {{ Success_count }}</p>
						<p>Failure Count : {{ Failure_count }}</p>
					</div>
					<div v-else-if="isLoading">
						 <app-loader></app-loader>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript" src="node_modules/vuejs/dist/vue.min.js"></script>
<script type="text/javascript"
	src="node_modules/vue-simple-search-dropdown/dist/vue-simple-search-dropdown.min.js"></script>
<script>
	import axios from "axios";
	import VueGoogleAutocomplete from 'vue-google-autocomplete'
	import VueToast from 'vue-toast-notification';
	import 'vue-toast-notification/dist/index.css';
	import assessmentname from "./views/assessmentname.vue";
	import loader from "./views/loader.vue"
	Vue.use(VueToast);
	Vue.component('v-select', VueSelect.VueSelect);
	export default {
		components: {
			"assessmentname": assessmentname,
			"app-loader": loader,
			VueGoogleAutocomplete
		},
		data: function () {
			return {
				googlemaps: '',
				scheduleReq: [],
				Total_count : "",
				Success_count : "",
				Failure_count : "",
				isfile : false,
				isLoading:false,
				errorblock :false,
				autocomplete : "",
				places : "",
				location : "",
				formatted_address : "",
				bulk_upload : false,
				location_error : false,
				isNext : true,
			};
		},
		mounted() {
			this.locationchanged()
		},
		methods: {
			locationchanged(){
				google.maps.event.addDomListener(window, 'load', initialize);
			function initialize(){
			 this.autocomplete = new google.maps.places.Autocomplete(document.getElementById("googlemaps"));
			google.maps.event.addListener(autocomplete, function() {
			this.formatted_address = autocomplete.getPlace().formatted_address;
			document.getElementById("googlemaps").attr("disabled", "disabled")
});
			}		
			},
			next(e){
				if(!autocomplete.getPlace()){
					this.location_error = true;
					this.bulk_upload = false;
				}
				else{
					this.bulk_upload = true;
					this.location_error = false;
					this.isNext = false;
				}
			},
			handleFileChange(e) {
				let places = autocomplete.getPlace();
				let formattedAddress = places.formatted_address;
				let lat = places.geometry.location.lat();
    		let lng = places.geometry.location.lng();
				var place_id = places.place_id;
				let url = places.url;
				console.log(formattedAddress)
				this.isLoading = true;
				let access_token = this.$route.query.access_token;
				var success = 0;
				var failed = 0
				var requests = null;
				this.$emit('input', e.target.files[0])
				const formData = new FormData();
				formData.append("file", e.target.files[0]);
				axios.post("https://utilities.talview.com/api/spreadsheet", formData)
					.then(response => {
						this.isLoading = true;
						let scheduleReq = response.data.data;
						requests = response.data.data.map(element => {
							element.location = { formattedAddress: formattedAddress, place_id: place_id ,url : url}
							element.location.coordinate = {lat:lat,lng:lng}
							element.panel = { id: 30876 }
							element.isOffline = 1
							return new Promise((resolve, reject) => {
								axios.request({
									method: "POST",
									baseURL: "https://utilities.talview.com/api/actions/live-schedule",
									headers: {
            			Authorization: `Bearer ${access_token}`
          				},
									data: element,
									json: true
								}).then(response => {
									this.isLoading = true;
									resolve(response);
								}).catch((err) => {
									this.errorblock = true;
									this.isLoading = false;
									resolve(err);
								})
							})
						})
						Promise.all(requests).then((body) => {
							let success = 0;
							let failed = 0;
							body.map((item) => {
								if (item.data && item.status == 201) {
									success++;
								}
								else {
									failed++;
									var fail = item.response.data
								}
							})
							this.isfile = true;
							this.Total_count = body.length;
							this.Success_count = success;
							this.Failure_count = failed;
						}).catch(error => {
							this.isfile = false;
							this.isLoading = false;
							this.errorblock = true;
							Vue.$toast.open({
							message: 'Please try again later',
							type: 'error',
							queue: true,
							dismissible: true,
							autoDismiss: true
						})
				});
					})
					.catch(error => {
							this.isLoading = false;
							Vue.$toast.open({
							message: 'Please choose csv or .xls file',
							type: 'error',
							queue: true,
							dismissible: true,
							autoDismiss: true
						})
					});
			},
			forceFileDownload(response) {
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', 'file.png') //or any other extension
				document.body.appendChild(link)
				link.click()
			},

			downloadWithAxios() {
				axios({
					method: 'get',
					url: this.url,
					responseType: 'arraybuffer'
				})
					.then(response => {
						this.isLoading = true;
						this.forceFileDownload(response)

					})
					.catch((error) =>{
							this.errorblock = true;
							Vue.$toast.open({
							message: 'Something went wrong Please try again',
							type: 'error',
							queue: true,
							dismissible: true,
							autoDismiss: true
						})
					})
			}
		},
	}
</script>
<style scoped>
	#file-select>input[type="file"] {
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/dropdown.vue